<template>
  <vs-popup :title="title" :active.sync="addNewDataLocal" @vs-close="closeForm">
    <!-- <vs-row vs-w="12"> -->
    <vs-col
      vs-justify="center"
      vs-align="center"
      vs-lg="12"
      vs-sm="12"
      vs-xs="12">
      <div
        class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary">
        <vs-row>
          <!-- icon -->
          <h3>Are you sure want to delete this?</h3>
        </vs-row>
        <p>This proccess canot be undone</p>
      </div>
    </vs-col>
    <!-- </vs-row> -->

    <vs-divider />
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button
          color="danger"
          type="filled"
          class="mr-3 mb-2 btn-submit vs-con-loading__container"
          @click="submitsForm()">
          Submit
        </vs-button>
        <vs-button color="primary" type="border" class="mb-2" @click="closeForm"
          >Cancel</vs-button
        >
      </div>
    </div>
  </vs-popup>
</template>

<script>
import * as REPO from '../../../repository/index'

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    id: String,
    title: String,
    type: String,
  },
  data() {
    return {
      model_array: [],
      active_array: [
        {
          label: 'Active',
          value: 1,
        },
        {
          label: 'Inactive',
          value: 0,
        },
        {
          label: 'Suspend',
          value: 2,
        },
      ],
      brand_name: '',
      disableTakeout: false,
      end_points: [],
      description: '',
      status: 1,
      status_awal: 1,
    }
  },
  computed: {
    addNewDataLocal: {
      get() {
        if (!this.editMode) this.clearFields()
        return JSON.parse(this.isOpen)
      },
      set(val) {
        if (!val) {
          //
          this.$emit('closeModal')
        }
      },
    },
    validateForm() {
      return !this.errors.any() && this.mailTo != ''
    },
  },
  methods: {
    submitsForm() {
      this.disableTakeout = true
      this.loadingBtnStart('btn-load-3')
      let param = {
        id: this.id,
      }

      switch (this.type) {
        case 'brand':
          REPO.deleteBrand(param.id)
            .then((res) => {
              this.clearFields()
              this.disableTakeout = false
              this.reasonPopUp = false
              this.loadingBtnStop('btn-load-3')
              this.$emit('submitModal', false)
              this.$toast.success('Data Successfully Take Out')
            })
            .catch((err) => {
              this.disableTakeout = false
              this.loadingBtnStop('btn-load-3')
              this.$toast.error(err.message)
            })
          break

        case 'model':
          REPO.deleteModel(param.id)
            .then((res) => {
              this.clearFields()
              this.disableTakeout = false
              this.reasonPopUp = false
              this.loadingBtnStop('btn-load-3')
              this.$emit('submitModal', false)
              this.$toast.success('Data Successfully Take Out')
            })
            .catch((err) => {
              this.disableTakeout = false
              this.loadingBtnStop('btn-load-3')
              this.$toast.error(err.message)
            })
          break

        default:
          this.loadingBtnStop('btn-load-3')
          this.$toast.error('Invalid Type')
          break
      }
      this.closeForm()
    },
    closeForm() {
      //
      this.clearFields()
      this.$emit('closeModal', false)
    },
    clearFields() {
      this.loadingBtnStop('btn-submit')
      //   this.brand_name = ''
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
  },
}
</script>

<style lang="scss" scoped></style>
